import { Link, useLocation } from "react-router";
import { montarTrilha } from "../../nucleo/trilha";

export interface PropsDaTrilha {
  /** Substitui o título de um caminho — ex.: `{ "/admin/implantacoes/abc": "Malwee" }`. */
  rotulos?: Readonly<Record<string, string>>;
}

/**
 * "Você está aqui", com o caminho de volta.
 *
 * Fica na casca, não nas páginas: assim vale para toda rota com sessão, inclusive as que
 * ainda não existem. Some sozinha na raiz de cada área, onde não há para onde subir.
 */
export function Trilha({ rotulos }: PropsDaTrilha) {
  const { pathname } = useLocation();
  const degraus = montarTrilha(pathname, rotulos);

  if (degraus.length === 0) return null;

  return (
    <nav className="trilha" aria-label="Trilha de navegação" data-testid="trilha">
      <ol className="trilha__lista">
        {degraus.map((degrau, indice) => {
          const atual = indice === degraus.length - 1;
          return (
            <li key={degrau.caminho} className="trilha__item">
              {atual ? (
                // A página atual não é link: clicar nela não leva a lugar nenhum, e o
                // leitor de tela precisa saber onde a pessoa está.
                <span className="trilha__atual" aria-current="page">
                  {degrau.titulo}
                </span>
              ) : (
                <Link to={degrau.caminho} className="trilha__link">
                  {degrau.titulo}
                </Link>
              )}
              {atual ? null : (
                <span className="trilha__separador" aria-hidden="true">
                  /
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
